



import { Vue, Component } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import OrderBuyConfirm from './OrderBuyConfirm.vue';
@Component({
  components: { AdminIframe, OrderBuyConfirm },
})
export default class OrderBuyConfirmIframe extends Vue {
  private get remoteSrc() {
    const query = this.$route.query;
    const queryObject = { ...query, serviceType: 'PRO' };
    const queryString = new URLSearchParams(queryObject).toString();
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/fulfillment/order/confirmed-purchase' + '?' + queryString;
    return src;
  }
}
